var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8OpenLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-open-link 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3302 1C11.0896 1 10.9057 1.18396 10.9057 1.42453C10.9057 1.66509 11.0896 1.84906 11.3302 1.84906H14.5567L7.99062 8.41515C7.82081 8.58496 7.82081 8.85372 7.99062 9.00938C8.07553 9.09428 8.18868 9.13679 8.28774 9.13679C8.38679 9.13679 8.49994 9.09428 8.58485 9.00938L15.1509 2.44329V5.66981C15.1509 5.91038 15.3349 6.09434 15.5755 6.09434C15.816 6.09434 16 5.91038 16 5.66981V1.42453C16 1.18396 15.816 1 15.5755 1H11.3302ZM2.83962 3.83019C1.82075 3.83019 1 4.65094 1 5.66981V14.1604C1 15.1792 1.82075 16 2.83962 16H11.3302C12.3491 16 13.1698 15.1792 13.1698 14.1604V7.79245C13.1698 7.55189 12.9858 7.36792 12.7453 7.36792C12.5047 7.36792 12.3208 7.55189 12.3208 7.79245V14.1604C12.3208 14.7123 11.8821 15.1509 11.3302 15.1509H2.83962C2.28774 15.1509 1.84906 14.7123 1.84906 14.1604V5.66981C1.84906 5.11792 2.28774 4.67925 2.83962 4.67925H9.20755C9.44811 4.67925 9.63208 4.49528 9.63208 4.25472C9.63208 4.01415 9.44811 3.83019 9.20755 3.83019H2.83962Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8OpenLink);
export default __webpack_public_path__ + "static/media/icons8-open-link.f06f6bb776374c256201930321bf7750.svg";
export { ForwardRef as ReactComponent };